import { render, staticRenderFns } from "./SocketComponent.vue?vue&type=template&id=59d95055&scoped=true&"
import script from "./SocketComponent.vue?vue&type=script&lang=js&"
export * from "./SocketComponent.vue?vue&type=script&lang=js&"
import style0 from "./SocketComponent.vue?vue&type=style&index=0&id=59d95055&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d95055",
  null
  
)

export default component.exports